export default __webpack_public_path__ + "static/media/createDarkMode.d9b9ba8c.svg";